export default "__VITE_ASSET__DJRJmZN8__"